import useSWR from "swr";
import fetchBoardColumns from "./fetchBoardColumns";
import useTokenHook from "../../context/useTokenHook";
import useUser from "../../context/userHook";

const useGetBoardColumns = (boardIds: number[]) => {
  const { token } = useTokenHook();
  const { userId, accountId } = useUser();

  const key = token && userId && accountId && boardIds.length > 0 ? `boardColumns:${boardIds.join(",")}:${userId}:${accountId}` : null;

  const fetcher = async () => await fetchBoardColumns(boardIds);

  const { data, error, isValidating, isLoading, mutate } = useSWR(key, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 10000, // Cache for 5 minutes
  });

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useGetBoardColumns;
